import React from "react";
import TermsOfUse from "../Modal/TermsOfUse";

export default () => (
<>
<div className="row no-gutters t-dashboardFooterArea">
    <div className="col-auto px-2"><a
                      href="#termOfUseModal"                    
                      data-toggle="modal"
                      data-target="#termOfUseModal"
                    >
                      Kullanım Koşulları

                    </a></div>
    <div className="col-auto px-2"><a href="https://www.eminevim.com/kvkk"  target="_blank">Kişisel Verilerin Korunması</a></div>
    <div className="col-auto px-2"><a href="https://www.eminevim.com/subeler"  target="_blank">Şubelerimiz</a></div>
  </div>
    <TermsOfUse></TermsOfUse>
</>
  

);
